<template>
  <section class="section container pt-0">
    <div class="title is-5 has-text-centered">
      {{ $t("payroll payment review") }}
    </div>

    <div v-if="payroll" class="box">
      <!-- Payroll Information -->
      <div class="card mb-5">
        <header class="card-header">
          <p class="card-header-title">
            <span class="icon">
              <i class="fa fa-calendar"></i>
            </span>
            {{ $t("payroll information") }}
          </p>
        </header>
        <div class="card-content">
          <div class="content">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">{{ $t("payroll name") }}</label>
                  <div class="control">
                    <p class="is-size-5">{{ payroll.payroll.name }}</p>
                  </div>
                  <span class="tag" :class="getStatusClass(payroll.status)">
                    <span class="icon">
                      <i :class="getStatusIcon(payroll.status)"></i>
                    </span>
                    <span>{{ $t(payroll.status) }}</span>
                  </span>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">{{ $t("period") }}</label>
                  <div class="control">
                    <div>
                      <span class="tag is-dark mr-2 is-medium">
                        <span class="icon is-small">
                          <i class="fa fa-calendar has-text-primary"></i>
                        </span>
                        <span>
                          {{ format_date(payroll.payroll.from_date) }}</span
                        >
                      </span>
                      <span class="tag is-dark is-medium">
                        <span class="icon is-small">
                          <i class="fa fa-calendar has-text-warning"></i>
                        </span>
                        <span> {{ format_date(payroll.payroll.to_date) }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">{{ $t("payroll uuid") }}</label>
                  <div class="control">
                    <p class="has-family-monospace">
                      {{ payroll.payroll.uuid }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">{{ $t("include salary") }}</label>
                  <div class="control">
                    <span
                      class="tag"
                      :class="
                        payroll.payroll.settings.include_salary
                          ? 'is-success'
                          : 'is-danger'
                      "
                    >
                      <span class="icon is-small">
                        <i
                          :class="
                            payroll.payroll.settings.include_salary
                              ? 'fa fa-check'
                              : 'fa fa-times'
                          "
                        ></i>
                      </span>
                      <span>{{
                        payroll.payroll.settings.include_salary
                          ? $t("yes")
                          : $t("no")
                      }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="field" v-if="payroll.payroll.settings.notes">
              <label class="label">{{ $t("notes") }}</label>
              <div class="control">
                <div class="notification is-dark">
                  <span class="icon">
                    <i class="fa fa-sticky-note"></i>
                  </span>
                  {{ payroll.payroll.settings.notes }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Employee Information -->
      <div class="card mb-5">
        <header class="card-header">
          <p class="card-header-title">
            <span class="icon">
              <i class="fa fa-user"></i>
            </span>
            {{ $t("employee information") }}
          </p>
        </header>
        <div class="card-content">
          <div class="content">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">{{ $t("full name") }}</label>
                  <div class="control">
                    <p class="is-size-5">
                      {{ payroll.member.first_name }}
                      {{ payroll.member.second_name }}
                      {{ payroll.member.first_surname }}
                      {{ payroll.member.second_surname }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column">
                <!-- <div class="field">
                  <label class="label">{{ $t("employee uuid") }}</label>
                  <div class="control">
                    <p class="has-family-monospace">
                      {{ payroll.member.uuid }}
                    </p>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Summary -->
      <div class="card mb-5">
        <header class="card-header">
          <p class="card-header-title">
            <span class="icon">
              <i class="fa fa-money-bill-wave"></i>
            </span>
            {{ $t("payment summary") }}
          </p>
        </header>
        <div class="card-content">
          <div class="content">
            <div class="columns">
              <div
                class="column"
                :class="
                  payroll.payroll.settings.include_salary ? 'is-3' : 'is-5'
                "
                v-if="payroll.payroll.settings.include_salary"
              >
                <div class="box has-background-primary-dark has-text-white">
                  <div class="level">
                    <div class="level-left">
                      <div class="level-item">
                        <div>
                          <p class="heading has-text-white">
                            {{ $t("base salary") }}
                          </p>
                          <p class="title has-text-white">
                            <span class="icon">
                              <i class="fa fa-dollar-sign"></i>
                            </span>
                            {{ formatCurrency(payroll.salary) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="column"
                :class="
                  payroll.payroll.settings.include_salary ? 'is-3' : 'is-4'
                "
              >
                <div class="box has-background-info-dark has-text-white">
                  <div class="level">
                    <div class="level-left">
                      <div class="level-item">
                        <div>
                          <p class="heading has-text-white">
                            {{ $t("bonus") }}
                          </p>
                          <p class="title has-text-white">
                            <span class="icon">
                              <i class="fa fa-plus"></i>
                            </span>
                            {{ formatCurrency(payroll.bonus) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="column"
                :class="
                  payroll.payroll.settings.include_salary ? 'is-3' : 'is-4'
                "
              >
                <div class="box has-background-danger-dark has-text-white">
                  <div class="level">
                    <div class="level-left">
                      <div class="level-item">
                        <div>
                          <p class="heading has-text-white">
                            {{ $t("deductions") }}
                          </p>
                          <p class="title has-text-white">
                            <span class="icon">
                              <i class="fa fa-minus"></i>
                            </span>
                            {{ formatCurrency(payroll.deductions) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="column"
                :class="
                  payroll.payroll.settings.include_salary ? 'is-3' : 'is-4'
                "
              >
                <div class="box has-background-success-dark has-text-white">
                  <div class="level">
                    <div class="level-left">
                      <div class="level-item">
                        <div>
                          <p class="heading has-text-white">
                            {{ $t("total") }}
                          </p>
                          <p class="title has-text-white">
                            <span class="icon">
                              <i class="fa fa-coins"></i>
                            </span>
                            {{ formatCurrency(calculateTotal()) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="card">
        <div class="card-content">
          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <p class="subtitle is-6">
                  <span class="icon">
                    <i class="fa fa-gavel"></i>
                  </span>
                  {{ $t("payroll actions") }}
                </p>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <div class="field is-grouped">
                  <div class="control">
                    <button
                      class="button is-danger is-outlined"
                      :class="{ 'is-loading': isRejecting }"
                      :disabled="
                        isProcessing || payroll.status !== 'registered'
                      "
                      @click="rejectPayroll"
                    >
                      <span class="icon">
                        <i class="fa fa-times"></i>
                      </span>
                      <span>{{ $t("reject payment") }}</span>
                    </button>
                  </div>
                  <div class="control">
                    <button
                      class="button is-success"
                      :class="{ 'is-loading': isApproving }"
                      :disabled="
                        isProcessing || payroll.status !== 'registered'
                      "
                      @click="approvePayroll"
                    >
                      <span class="icon">
                        <i class="fa fa-check"></i>
                      </span>
                      <span>{{ $t("approve payment") }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Status Information -->
          <div
            v-if="payroll.status !== 'registered'"
            class="notification is-dark"
          >
            <div class="media">
              <div class="media-left">
                <span class="icon">
                  <i :class="getStatusIcon(payroll.status)"></i>
                </span>
              </div>
              <div class="media-content">
                <p>
                  <strong>{{ $t("current status") }}</strong>
                  <span :class="'tag ml-2 ' + getStatusClass(payroll.status)">
                    {{ $t(payroll.status) }}
                  </span>
                </p>
                <p class="is-size-7 mt-2">
                  {{ getStatusMessage(payroll.status) }}
                </p>
              </div>
            </div>
          </div>

          <!-- Approval/Rejection Details -->
          <div
            v-if="payroll.approved_data"
            class="notification is-success mt-3"
          >
            <div class="media">
              <div class="media-left">
                <span class="icon">
                  <i class="fa fa-user"></i>
                </span>
              </div>
              <div class="media-content">
                <p>
                  <strong>{{ $t("approved by") }}:</strong>
                  {{ payroll.approved_data.by }}<br />
                  <strong>{{ $t("approval date") }}:</strong>
                  {{ payroll.approved_data.date }}
                </p>
                <div v-if="payroll.approved_data.signature" class="mt-0">
                  <strong>{{ $t("digital signature") }}:</strong>
                  <div class="box has-background-white mt-2 p-3">
                    <figure class="image" style="max-width: 300px">
                      <img
                        :src="payroll.approved_data.signature"
                        :alt="$t('approval signature')"
                        style="border: 1px solid #dbdbdb; border-radius: 4px"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="payroll.rejected_data" class="notification is-danger mt-3">
            <div class="media">
              <div class="media-left">
                <span class="icon">
                  <i class="fa fa-user-times"></i>
                </span>
              </div>
              <div class="media-content">
                <p>
                  <strong>{{ $t("rejected by") }}:</strong>
                  {{ payroll.rejected_data.by }}<br />
                  <strong>{{ $t("rejection date") }}:</strong>
                  {{ payroll.rejected_data.date }}
                </p>
                <div v-if="payroll.rejected_data.reason" class="mt-0">
                  <strong>{{ $t("rejection reason") }}:</strong>
                  <div class="box has-background-white-ter mt-2">
                    <p class="has-text-dark">
                      {{ payroll.rejected_data.reason }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="box">
      <div class="notification is-warning">
        <span class="icon">
          <i class="fa fa-exclamation-triangle"></i>
        </span>
        {{ $t("loading payroll information...") }}
      </div>
    </div>
    <sign-modal ref="payroll_sign_modal"></sign-modal>
  </section>
</template>

<script>
import {
  get,
  post,
  format_currency,
  format_date,
  error_message,
  success_message,
  confirm_deletion_dialog,
  input_alert,
} from "@/utils";
import SignModal from "./payroll_review_sign_modal/Index.vue";

export default {
  name: "StaffPayrollReview",
  components: { SignModal },
  data() {
    return {
      payroll: null,
      isApproving: false,
      isRejecting: false,
    };
  },
  computed: {
    isProcessing() {
      return this.isApproving || this.isRejecting;
    },
  },
  methods: {
    formatCurrency: format_currency,
    format_date: format_date,
    calculateTotal() {
      if (!this.payroll) return 0;

      let total = parseFloat(this.payroll.bonus || 0);

      if (this.payroll.payroll?.settings?.include_salary) {
        total += parseFloat(this.payroll.salary || 0);
      }

      // Subtract deductions from the total
      total -= parseFloat(this.payroll.deductions || 0);

      return Math.max(0, total); // Ensure total doesn't go negative
    },
    getStatusClass(status) {
      const statusClasses = {
        registered: "is-warning",
        approved: "is-success",
        rejected: "is-danger",
        processed: "is-success",
        paid: "is-success",
        cancelled: "is-dark",
      };
      return statusClasses[status] || "is-dark";
    },
    getStatusIcon(status) {
      const statusIcons = {
        registered: "fa fa-clock-o",
        approved: "fa fa-check",
        rejected: "fa fa-times",
        processed: "fa fa-check-circle",
        paid: "fa fa-money",
        cancelled: "fa fa-ban",
      };
      return statusIcons[status] || "fa fa-question-circle";
    },
    getStatusMessage(status) {
      const messages = {
        approved: this.$t("payroll payment has been approved"),
        rejected: this.$t("payroll payment has been rejected"),
        registered: this.$t("payroll payment is pending approval"),
      };
      return messages[status] || "";
    },
    approvePayroll() {
      if (!this.payroll || this.payroll.status !== "registered") return;

      this.isApproving = true;
      try {
        this.$refs.payroll_sign_modal.open(this.payroll.uuid);
      } catch (error) {
        console.error("Error approving payroll:", error);
        error_message(error);
      }
    },
    rejectPayroll() {
      let v = this;
      if (!this.payroll || this.payroll.status !== "registered") return;

      input_alert({
        title: v.$t("reason for rejection"),
        text: v.$t("please provide a reason for rejecting this payroll"),
      })
        .then((reason) => {
          if (!reason) {
            error_message(v.$t("rejection reason is required"));
            return;
          } else {
            v.isRejecting = true;
            post("/staff/payroll/review/reject", {
              uuid: v.payroll.uuid,
              reason: reason,
            })
              .then((response) => {
                success_message(v.$t("payroll rejected successfully"));
              })
              .catch((error) => {
                error_message(error);
                console.error("Error rejecting payroll:", error);
              })
              .finally(() => {
                v.isRejecting = false;
              });
          }
        })
        .catch((err) => {
          console.error("Rejection cancelled or error:", err);
        });
    },
  },
  mounted() {
    let v = this;
    let uuid = v.$route.params.uuid;
    if (uuid) {
      get("/staff/payroll/review", { uuid: uuid })
        .then((response) => {
          v.payroll = response;
        })
        .catch((error) => {
          console.error("error retrieving payroll review data", error);
        });
    }
  },
  created() {},
};
</script>

<style scoped></style>
